<template>
    <LightBox v-show="!!openedPicture" :picture="openedPicture" :title="mainHeadline" @close="closePicture" @next="nextPicture" @previous="prevPicture" />
    <div class="content-side">
        <div class="content" :style="isGallery ? { marginBottom: '10px' } : {}">
            <ParseWYSIWYG :id="Number($route.params.newID)" :kicker="kicker" :mainHeadline="mainHeadline" :deck="deck" :lead="lead" :content="content.ops" :createdDate="(new Date(createdDatetime)).toLocaleDateString(t('timeLocale'))" :createdTime="(new Date(createdDatetime)).toLocaleTimeString(t('timeLocale')).match(/^..?:..?/g)[0]" :pictures="pictures" :vin="vin" :topic="topic" :isGallery="isGallery" :video="video" :needToBoldVideo="needToBoldVideo" />
        </div>
    </div>

    <div class="related-box" v-if="pictures.other.length || (video && !needToBoldVideo) || (auth && auth.news.edit)" style="padding-top: 50px;">
        <span class="title" v-if="!isGallery" style="margin-top: 0;">{{ t('visitNews.gallery') }}</span>
        <div class="news">
            <div class="news-post-2" v-for="(picture, index) in (pictures.other ?? [])" :key="index" @click="gotoPicture">
                <img :src="picture ? (`${VUE_APP_SERVER_ROOT}picture/` + picture) : '/img/404Picture.png'" alt="">
                <span @click.prevent="remGalleryPicture(picture)" v-if="auth ? auth.news.delete : false" style="position: absolute; margin-top: 225px; font-size: 14px; font-weight: bold; color: #8a5f2e; margin-right: -40px;">حذف &times;</span>
            </div>
        </div>
        <button v-if="auth ? auth.news.edit : false" type="button" class="btn btn-green" style="margin: 20px auto;" @click="addGalleryPicture">{{ t('visitNews.newPic') }}</button>
        <div class="news">
            <video v-if="video && !needToBoldVideo" controls>
                <source :src="`${VUE_APP_SERVER_ROOT}video/` + video" type="video/mp4">
            </video>
            <span @click.prevent="remVideo()" v-if="auth ? auth.news.delete : false" style="position: absolute; margin-top: 370px; font-size: 14px; font-weight: bold; color: #8a5f2e; margin-right: 0; cursor: pointer">حذف &times;</span>
        </div>
    </div>
</template>

<script>
import Delta from 'quill-delta';
import ParseWYSIWYG from '@/components/parseWysiwyg'
import { useAuth } from '@/authentication'
import LightBox from '@/components/LightBox.vue'
import $ from 'jquery'
import { useI18n } from 'vue-i18n'


export default {
    name: "NewsView",
    components: { ParseWYSIWYG, LightBox },
    mixins: [],
    data: () => ({
        kicker: "",
        mainHeadline: "",
        deck: "",
        lead: "",
        content: new Delta,
        createdDatetime: 0,
        pictures: {other:[]},
        vin: false,
        video: null,
        topic: "",
        Number,
        VUE_APP_SERVER_ROOT: process.env.VUE_APP_SERVER_ROOT,
        auth: useAuth(),
        openedPicture: false,
        isGallery: false,
        t: useI18n().t,
        locale: useI18n().locale
    }),
    methods: {
        remGalleryPicture(pictureName) {
            if (confirm("آیا مطمئنید می‌خواهید این تصویر را حذف کنید؟")) $.ajax({
                url: `${process.env.VUE_APP_SERVER_ROOT}delete-picture`,
                method: "POST",
                data: { pictureName },
                xhrFields: {
                    withCredentials: true
                },
                dataType: "json",
                success(data) {
                    if (data.STATUS) {
                        alert("حذف شد")
                        location.reload()
                    } else {
                        alert(`حذف موفقیت آمیز نبود؛ ${data.REASON}`)
                    }
                },
                error() {
                    alert("ارسال درخواست موفقیت آمیز نبود")
                }
            })
        },
        addGalleryPicture() {
            const fileInp = document.createElement('INPUT')
            fileInp.setAttribute("type", "file")
            fileInp.setAttribute("accept", "image/png,.jpeg,.jpg")
            fileInp.setAttribute("multiple", true)
            $(fileInp).change(e => {
                const fd = new FormData
                // fd.append("files", fileInp.files)
                Array.from(fileInp.files).forEach((file, i) => {
                    fd.append("files[" + i + "]", file)
                })
                fd.append("newID", this.$route.params.newID)
                $.ajax({
                    url: `${process.env.VUE_APP_SERVER_ROOT}new-gallery-picture`,
                    method: "POST",
                    data: fd,
                    xhrFields: { withCredentials: true },
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success(data) {
                        if (data.STATUS) {
                            alert('ذخیره شد')
                            location.reload()
                        } else {
                            alert(data.REASON)
                        }
                    }, 
                    error() {
                        alert('ارسال اطلاعات ممکن نبود')
                    }
                })
            })
            $(fileInp).click()
        },
        gotoPicture($e) {
            if ($e.target.nodeName == 'SPAN') return false
            const pic = $e.target.getAttribute("src")
            this.openedPicture = pic
            setTimeout(() => {
                document.querySelector('.light-box').focus()
            }, 1000);
        },
        closePicture() {
            this.openedPicture = false;
        },
        nextPicture() {
            if (Number(/n(?<num>\d+)$/.exec(this.openedPicture).groups.num) < this.pictures.other.length)
                this.openedPicture = `${/^(?<o>.+n)(\d+)$/.exec(this.openedPicture).groups.o}${Number(/n(?<num>\d+)$/.exec(this.openedPicture).groups.num) + 1}`
        },
        prevPicture() {
            if (Number(/n(?<num>\d+)$/.exec(this.openedPicture).groups.num) > 1)
                this.openedPicture = `${/^(?<o>.+n)(\d+)$/.exec(this.openedPicture).groups.o}${Number(/n(?<num>\d+)$/.exec(this.openedPicture).groups.num) - 1}`
        },
        remVideo() {
            if (confirm("آیا مطمئنید می‌خواهید فیلم خبر را حذف کنید؟")) $.ajax({
                url: `${process.env.VUE_APP_SERVER_ROOT}delete-video`,
                method: "POST",
                data: { newID: this.$route.params.newID },
                xhrFields: {
                    withCredentials: true
                },
                dataType: "json",
                success(data) {
                    if (data.STATUS) {
                        alert("حذف شد")
                        location.reload()
                    } else {
                        alert(`حذف موفقیت آمیز نبود؛ ${data.REASON}`)
                    }
                },
                error() {
                    alert("ارسال درخواست موفقیت آمیز نبود")
                }
            })
        }
    },
    computed: {
        needToBoldVideo: {
            get() {
                return this.video && this.isGallery && !this.pictures.other.length
            }
        }
    },
    mounted() {
        if (this.$route.params.locale) this.locale = this.$route.params.locale
    },
    created() {
        const vueApp = this;

        $.ajax({
            url: `${process.env.VUE_APP_SERVER_ROOT}visit-new/${this.$route.params.newID}`,
            method: "GET",
            data: {
                school: this.$route.params.school ? this.$route.params.school.replaceAll('-','_') : undefined
            },
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            },
            success(data) {
                if (data.STATUS) {
                    vueApp.kicker = data.KICKER;
                    vueApp.mainHeadline = data.MAIN_HEADLINE;
                    vueApp.deck = data.DECK;
                    vueApp.lead = data.LEAD;
                    vueApp.content = new Delta(data.CONTENT);
                    vueApp.createdDatetime = data.CREATED_DATETIME;
                    vueApp.pictures = data.PICTURES;
                    vueApp.vin = data.VIN;
                    vueApp.video = data.VIDEO_NAME;
                    vueApp.topic = data.TOPIC;
                    vueApp.isGallery = data.IS_GALLERY != 'no';
                } else { // { time: (new Date(data.CREATED_DATETIME)).toLocaleTimeString(t('timeLocale')).match(/^..?:..?/g)[0], date: (new Date(data.CREATED_DATETIME)).toLocaleDateString(t('timeLocale')) }
                    alert(data.REASON ?? "دریافت اطلاعات موفقیت آمیز نبود")
                    location.href = "/" + (vueApp.$route.params.locale ? vueApp.$route.params.locale + '/' : '') + (vueApp.$route.params.school ? vueApp.$route.params.school + '/' : '');
                }
            },
            error() {
                alert("ارتباط با سرور برقرار نشد")
            }
        })
    }
}
</script>

<style lang="less" scoped>

video {
    height: 360px;
    border-radius: 10px;
}

</style>